import { useContext, useMemo } from 'react';

import { URLStateContext } from '../URLState/URLState';
import getTicksFromStep from '../../utils/metric/getTicksFromStep';
import getStepFromTimeRange from '../../utils/time/getStepFromTimeRange';
import getTimeRange from '../../utils/time/getTimeRange';

const useTimeSeriesAxis = (): number[] => {
  const urlState = useContext(URLStateContext);
  const { dateFrom, dateTo } = getTimeRange(urlState.duration, urlState.dateFrom, urlState.dateTo);
  const step = getStepFromTimeRange(dateFrom, dateTo);

  return useMemo(() => getTicksFromStep(dateFrom, dateTo, step), [dateFrom, dateTo, step]);
};

export default useTimeSeriesAxis;
